export default __webpack_public_path__ + "static/media/customer_support.8d3a3371.jpg";